module.exports = __webpack_public_path__ + "img/img-p2.a8270d5e.jpg";